import React, { forwardRef } from "react";
import Chip from "@mui/material/Chip";
import { getClassName } from "@sscs/utils";
import { SearchIcon } from "../../icons";
import styles from "./searchChip.module.scss";
const SearchChip = forwardRef(({ label, ...props }, ref) => {
    return (React.createElement(Chip, { ...props, ref: ref, clickable: true, label: React.createElement(React.Fragment, null,
            label,
            React.createElement(SearchIcon, { size: "xs", color: "interactive" })), className: getClassName(styles["search-chip"], props.className) }));
});
SearchChip.displayName = "SearchChip";
export default SearchChip;
//# sourceMappingURL=SearchChip.js.map